import {
  Show,
  TabbedShowLayout,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
} from '@mui/material';
import { ChannelType, type Channel } from '../../types/chat.types';
import { ZapyChannelShow } from './show/zapy';
import { TelegramChannelShow } from './show/telegram';
import { ChannelHeader, ChannelDetails, ChannelConnections } from './show/components';

export const ChannelShow = () => {
  return (
    <Show>
      <ChannelShowContent />
    </Show>
  );
};

const ChannelShowContent = () => {
  const record = useRecordContext<Channel>();
  const translate = useTranslate();

  // For Zapy channels, show simplified single-page view
  if (record?.type === ChannelType.ZAPY) {
    return (
      <Box p={2}>
        <ChannelHeader />
        <ZapyChannelShow />
      </Box>
    );
  }

  // For Telegram channels, show simplified single-page view
  if (record?.type === ChannelType.TELEGRAM) {
    return (
      <Box p={2}>
        <ChannelHeader />
        <TelegramChannelShow />
      </Box>
    );
  }

  // For other channel types, keep the tabbed layout
  return (
    <Box p={2}>
      <ChannelHeader />

      <TabbedShowLayout>
        <TabbedShowLayout.Tab label={translate('resources.channel.tabs.details')}>
          <ChannelDetails />
        </TabbedShowLayout.Tab>

        <TabbedShowLayout.Tab label={translate('resources.channel.tabs.connections')}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {translate('resources.channel.tabs.connections')}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <ChannelConnections />
            </CardContent>
          </Card>
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Box>
  );
};
